<!-- <header aria-label="Site header" class="header">
  <nav class="header-container wrapper">

    <a href="https://wrwa.gov.uk/" class="logo">
      <img src="assets/images/WRWA_logo.svg" alt="Western Riverside Site Logo">
    </a>

  </nav>

</header> -->
<header id="full-navigation" class="">
  <div id="desktop-logo" class="hidden-xs">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-5">
          <ul class="secondary-menu">
            <li id="menu-item-1376" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1376"><a
                href="https://wrwa.gov.uk/useful-resources/">Useful Resources</a></li>
            <li id="menu-item-1410" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1410"><a
                href="https://wrwa.gov.uk/contact/">Contact</a></li>
          </ul>
        </div>
        <div class="col-sm-2">
          <a href="https://wrwa.gov.uk"><img class="logo"
              src="https://wrwa.gov.uk/wp-content/themes/wrwa-theme/images/logo.svg" alt="WRWA Logo"></a>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <!-- NAV -->
    <nav id="topnav" class="navbar navbar-default">
      <div class="navbar-header">
        <a class="navbar-toggle" data-bs-toggle="collapse" data-bs-target="#navbar" aria-expanded="false" role="button"
          aria-controls="navbar">
          <span class="sr-only">Site Menu</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </a>
        <a class="navbar-brand visible-xs" href="https://wrwa.gov.uk"><img class="logo"
            src="https://wrwa.gov.uk/wp-content/themes/wrwa-theme/images/logo.svg" alt="WRWA Logo"></a>
      </div>
      <div class="visible-xs">
        <div id="navbar" class="navbar-collapse collapse" style="height: 399px;">
          <ul class="nav navbar-nav navbar-right navbar-custom">
            <li id="menu-item-1378"
              class="unclickable menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1378">
              <a href="#">Waste &amp; Recycling Centres</a>
              <ul class="sub-menu">
                <li id="menu-item-1379" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1379">
                  <a href="https://wrwa.gov.uk/centre-opening-times/">Book to visit the Smugglers Way HWRC</a>
                </li>
                <li id="menu-item-1386" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1386">
                  <a href="https://wrwa.gov.uk/a-z-of-materials/">A-Z of Materials</a>
                </li>
                <li id="menu-item-1719" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1719">
                  <a href="https://wrwa.gov.uk/reuse-workshop/">Reuse Workshop</a>
                </li>
                <li id="menu-item-1409" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1409">
                  <a href="https://wrwa.gov.uk/faqs/">Disposal of DIY Waste</a>
                </li>
              </ul>
            </li>
            <li id="menu-item-1384" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1384"><a
                href="https://wrwa.gov.uk/waste-authority/">Waste Authority</a></li>
            <li id="menu-item-1383" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1383"><a
                href="https://wrwa.gov.uk/schools-adult-groups/">Schools &amp; Adult Groups</a></li>
            <li id="menu-item-1385" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1385"><a
                href="https://wrwa.gov.uk/news-hot-topics/">News &amp; Hot Topics</a></li>
            <li id="menu-item-7351" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7351"><a
                href="https://wrwa.gov.uk/strategy/">Strategy</a></li>
            <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1376"><a
                href="https://wrwa.gov.uk/useful-resources/">Useful Resources</a></li>
            <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1410"><a
                href="https://wrwa.gov.uk/contact/">Contact</a></li>
          </ul>
        </div>
      </div><!--/.nav-collapse -->
      <div class="hidden-xs">
        <div id="navbar" class="navbar-collapse collapse">
          <ul class="nav navbar-nav navbar-right navbar-custom">
            <li
              class="unclickable menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1378">
              <a href="#">Waste &amp; Recycling Centres</a>
              <ul class="sub-menu">
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1379"><a
                    href="https://wrwa.gov.uk/centre-opening-times/">Book to visit the Smugglers Way HWRC</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1386"><a
                    href="https://wrwa.gov.uk/a-z-of-materials/">A-Z of Materials</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1719"><a
                    href="https://wrwa.gov.uk/reuse-workshop/">Reuse Workshop</a></li>
                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1409"><a
                    href="https://wrwa.gov.uk/faqs/">Disposal of DIY Waste</a></li>
              </ul>
            </li>
            <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1384"><a
                href="https://wrwa.gov.uk/waste-authority/">Waste Authority</a></li>
            <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1383"><a
                href="https://wrwa.gov.uk/schools-adult-groups/">Schools &amp; Adult Groups</a></li>
            <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1385"><a
                href="https://wrwa.gov.uk/news-hot-topics/">News &amp; Hot Topics</a></li>
            <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7351"><a
                href="https://wrwa.gov.uk/strategy/">Strategy</a></li>
          </ul>
        </div>
      </div><!--/.nav-collapse -->
    </nav>
  </div>

</header>